import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "../../axios";
import * as url from "../../utils/url"

const ContactUsModal = ({ isOpen, toggle }) => {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async () => {
    if (!message.trim()) {
      setError("Message required");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await axios.post(url.sendEmailToOurofficeSupport, { message });

      if (response.status === 200) {
        setSuccess("Message sent successfully!");
        setMessage("");
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      setError("Failed to send message. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Contact Us</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="message">Message</Label>
            <Input
              type="textarea"
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Enter your message"
              rows="4"
            />
          </FormGroup>
          {error && <p className="text-danger">{error}</p>}
          {success && <p className="text-success">{success}</p>}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={loading}>Cancel</Button>
        <Button  color="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? "Sending..." : "Send"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ContactUsModal;
